import { useRef, useState } from "react";
import { Play, Pause, Volume2, VolumeX } from "lucide-react";
import { PROMO_VIDEO } from "../mock";

const PromoVideo = () => {
  const vidRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);

  const toggle = () => {
    const v = vidRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    const v = vidRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  return (
    <div
      className="group relative overflow-hidden bg-plate cursor-pointer aspect-video border border-line"
      onClick={toggle}
      data-testid="promo-video-container"
    >
      <video
        ref={vidRef}
        src={PROMO_VIDEO.src}
        poster={PROMO_VIDEO.poster}
        className="w-full h-full object-cover"
        playsInline
        loop
        muted={muted}
        preload="metadata"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        data-testid="promo-video"
      />

      <div
        className={`absolute inset-0 bg-ink/10 transition-opacity duration-500 ${playing ? "opacity-0" : "opacity-100"}`}
      />

      {/* Oynat */}
      <div className={`absolute inset-0 flex items-center justify-center transition-opacity duration-500 ${playing ? "opacity-0 pointer-events-none" : "opacity-100"}`}>
        <span className="relative flex items-center justify-center">
          <span className="absolute w-24 h-24 rounded-full border border-white/70 animate-ping" />
          <span
            className="relative w-[76px] h-[76px] rounded-full bg-white text-ink flex items-center justify-center shadow-[0_16px_40px_rgba(26,26,26,0.18)] group-hover:bg-brand group-hover:text-white transition-colors duration-300"
            data-testid="promo-play-button"
          >
            <Play size={26} className="translate-x-0.5 fill-current" />
          </span>
        </span>
      </div>

      {/* Alt kontrol */}
      <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-5 sm:px-6 py-4 bg-gradient-to-t from-ink/55 to-transparent">
        <span className="text-white text-[11px] font-semibold tracking-[0.2em] uppercase flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-brand inline-block" />
          Koşan Düğme · Tanıtım
        </span>
        <div className="flex items-center gap-2">
          <button
            onClick={toggleMute}
            className="w-10 h-10 rounded-full flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm text-white transition-colors"
            aria-label={muted ? "Sesi aç" : "Sesi kapat"}
            data-testid="promo-mute-button"
          >
            {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); toggle(); }}
            className="w-10 h-10 rounded-full flex items-center justify-center bg-white/15 hover:bg-white/30 backdrop-blur-sm text-white transition-colors"
            aria-label={playing ? "Duraklat" : "Oynat"}
            data-testid="promo-toggle-button"
          >
            {playing ? <Pause size={16} /> : <Play size={16} className="translate-x-0.5" />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoVideo;
